module.exports = __webpack_public_path__ + "img/password.6ae67aac.png";